const processNameFile = file => {

  let nameNew = `${file.nome}.${file.ext}`
  let nameOld = null
  let nameBkp = null

  if (file.path_lower) {
    let nameContexto = file.path_lower.split('/').pop()
    let sep = nameContexto.lastIndexOf('.')
    nameOld = sep > 0 ? nameContexto.substr(0, sep) : nameContexto

  } else if (file.name) {
    let nameContexto = file.name
    let sep = nameContexto.lastIndexOf('.')
    nameOld = sep > 0 ? nameContexto.substr(0, sep) : nameContexto

  }

  nameBkp = nameOld.toUpperCase()
  if (nameOld) nameOld = `${nameOld}.${file.ext}`.toUpperCase()

  return { nameNew, nameOld, nameBkp}

}

const nameIsEquals = (filename1, filename2) => filename1.toUpperCase() == filename2.toUpperCase() ? true : false

const montaItemArquivoPreview = (item, chave_id, value, origin) => {
  const file = {
      id: item.id,
      pessoa_id: this.pessoa_id,
      nome: item.name,
      type: item.type,
      ext: item.extension,
      file: item.file,
      preview: item.preview.preview,
      [chave_id]: value,
      size: item.size ? item.size : 0,
      path_lower: item.path_lower,
      loading: false,
      downloadFile: false,
      progressFile: null,
      isMultiSelecionado: false,
      isEnviar: false,
      isErro: false,
      tipo: 'file',
      isUploading: false,
      isDeleting: false,
      isPromisse: false,
      isPromisseSend: false,
      hash: genIdTemp(),
      origin
  }
  return file
}

const ajustaArquivosPreview = (files, chave_id, value, origin)  => {
  const arrRet = []
  if (files.length) {
    files.forEach( async (item) => {
      let img = montaItemArquivoPreview(item, chave_id, value, origin)
      arrRet.push(Object.assign({}, img))
    })
  }
  return arrRet
}

const genIdTemp = () => {
  return Math.random().toString(36).slice(-10)
}

const manyFilesSending = files => {
  let arrUploading = files.filter(item => item.isUploading)
  return arrUploading.length > 2 ? true : false
}

const manyFilesDeleting = files => {
  let arrDeleting = files.filter(item => item.isDeleting)
  return arrDeleting.length > 3 ? true : false
}

const sleep = miliseconds => {
  return new Promise((resolve, reject) => {
      setTimeout(() => {
          resolve("The request is successful.");
      }, miliseconds);
  });
};

export {
  processNameFile,
  nameIsEquals,
  montaItemArquivoPreview,
  ajustaArquivosPreview,
  genIdTemp,
  manyFilesSending,
  manyFilesDeleting,
  sleep
}



// WEBPACK FOOTER //
// ./src/views/OrquestraFiles/_store/utils.js